import { useState } from 'react';
import { otpService } from '@services/otp.service';
import { logger } from '@utils/logger';

export const useOTP = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const sendPhoneOTP = async (phone) => {
    setLoading(true);
    setError(null);
    try {
      const response = await otpService.sendPhoneOTP(phone);
      setLoading(false);
      return response;
    } catch (err) {
      setError(err.message || 'Failed to send phone OTP');
      setLoading(false);
      throw err;
    }
  };

  const verifyPhoneOTP = async (userId, otp) => {
    setLoading(true);
    setError(null);
    try {
      const response = await otpService.verifyPhoneOTP(userId, otp);
      setLoading(false);
      return response;
    } catch (err) {
      setError(err.message || 'Failed to verify phone OTP');
      setLoading(false);
      throw err;
    }
  };

  const sendEmailOTP = async (userId, email, firstName, lastName) => {
    setLoading(true);
    setError(null);
    try {
      const response = await otpService.sendEmailOTP(userId, email, firstName, lastName);
      setLoading(false);
      return response;
    } catch (err) {
      setError(err.message || 'Failed to send email OTP');
      setLoading(false);
      throw err;
    }
  };

  const verifyEmailOTP = async (userId, otp) => {
    setLoading(true);
    setError(null);
    try {
      const response = await otpService.verifyEmailOTP(userId, otp);
      setLoading(false);
      return response;
    } catch (err) {
      setError(err.message || 'Failed to verify email OTP');
      setLoading(false);
      throw err;
    }
  };


  const resendOTP = async (userId, type) => {
    setLoading(true);
    setError(null);
    try {
      const response = await otpService.resendOTP(userId, type);
      setLoading(false);
      return response;
    } catch (err) {
      setError(err.message || 'Failed to resend OTP');
      setLoading(false);
      throw err;
    }
  }

  const clearError = () => setError(null);

  return {
    loading,
    error,
    sendPhoneOTP,
    verifyPhoneOTP,
    sendEmailOTP,
    verifyEmailOTP,
    resendOTP,
    clearError,
  };
};

export default useOTP;
